import React from "react";
import ImageTag from "../components/reuseable/imageTag.jsx";
import FormSection from "../components/signup-section/form.jsx";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

function Signup() {
  return (
    <div className="lg:h-screen flex items-center">
      <div className="flex w-full lg:h-screen rounded-xl">
        <div className="w-[55%] h-full hidden lg:flex lg:flex-col items-center justify-center bg-gradient-to-b from-[#3FC4E3] to-[#006077]">
          <ImageTag
            path="/assets/images/auth/thumbnail.png"
            classes="size-[460px]"
            altText="login"
          />
          <p className="font-popinsBold text-white text-4xl mt-8 text-center">
            One Platform.
          </p>
          <p className="font-popinsBold text-white text-4xl mt-2 text-center">
            Endless Community Possibilities.
          </p>
        </div>
        <div className=" w-full lg:w-[45%] h-screen lg:h-full my-auto flex flex-col items-center justify-center bg-bg-auth bg-no-repeat bg-center bg-cover">
          <div className="w-[90%] lg:w-[75%] mx-auto flex flex-col items-center justify-center">
            <div className="w-full h-full flex flex-col justify-center text-center">
              <Link to={"/"}>
                <div className="flex text-black/50 items-center gap-x-1 lg:ml-[-50px] font-popinsMedium">
                  <ChevronLeft size={18} />
                  <p>Back</p>
                </div>
              </Link>
              <h1 className="font-popinsBold  text-2xl 2xl:text-4xl mt-6">
                Create new account
              </h1>
              <p className="text-textColor mb-4 w-[70%] mx-auto">
                Welcome, please enter your detail.
              </p>
              <FormSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
